/**
 * Created by Olga on 13.10.2026
 */

const CollectibleHintLogic = {
    type: "collectible",
    priority: 2,

    findMove: function () {
        if (!Merge2.current || !Merge2.current.isGameMode() || Merge2.current.field.countEmptySlots() > 0) {
            return;
        }

        const units = Merge2.current.field.listAvailableUnits((unit) => unit.findComponent(Collectible) && !unit.isGrounded() && unit.onGetView() && !unit.isLast());
        if (!units.length) {
            return;
        }

        const unit = units.sort((a, b) => b.stage - a.stage)[0];

        return {
            type: CollectibleHintLogic.type,
            delay: 3000,
            target: unit.onGetView()
        };
    }
};

AvailableMove.REGISTERED_ALGORITHMS.push(CollectibleHintLogic);
